// Dependencies
import axios from "axios";
import { Modal, message } from "antd";
import { downloadPDF, downloadXLSX } from "../lib/utils";

const { REACT_APP_SERVER_URL, NODE_ENV } = process.env;
const dev = NODE_ENV === "development";

const baseURL = !dev ? REACT_APP_SERVER_URL : "http://localhost:8080";

const myFetch = (endpoint, config) => {
  const tokenApi = localStorage.getItem("tokenApi");
  const configFetch = {
    headers: {
      Authorization: `Bearer ${tokenApi}`,
    },
    ...config,
  };
  return axios(`${baseURL}/api${endpoint}`, configFetch);
};

export const get = (url, options) =>
  myFetch(url, { method: "GET", ...options });
export const post = (url, data, options) =>
  myFetch(url, { method: "POST", data, ...options });
export const put = (url, data, options) =>
  myFetch(url, { method: "PUT", data, ...options });
export const del = (url, data, options) =>
  myFetch(url, { method: "DELETE", data, ...options });

export const getPdf = (url, filename = "report.pdf", callback) => {
  const modal = Modal.info({
    title: "Imprimiendo...",
    content: `Por favor espere, se está descargando el informe`,
    closable: false,
    okButtonProps: {
      disabled: true,
    },
  });
  get(url, { responseType: "blob" })
    .then(({ data }) => {
      callback && callback();
      modal.destroy();
      downloadPDF(data, filename);
    })
    .catch((error) => {
      modal.destroy();
      message.error("Se produjo un error al descargar el informe");
    });
};

export const getXLSX = (url, filename = "datasheet.xlsx", callback) => {
  const modal = Modal.info({
    title: "Descargando...",
    content: `Por favor espere, se está descargando el archivo`,
    closable: false,
    okButtonProps: {
      disabled: true,
    },
  });
  get(url, { responseType: "blob" })
    .then(({ data }) => {
      callback && callback();
      modal.destroy();
      downloadXLSX(data, filename);
    })
    .catch((error) => {
      modal.destroy();
      message.error("Se produjo un error al descargar el archivo");
    });
};

export const allOperations = { get, post, put, del };
export default myFetch;
